import { LevelData } from '../level-data';

export const level14: LevelData = {
    name: 'Maze Runner',
    timeLimit: 100,
    track: [
        '-------',
        '-------',
        '-------',
        '-------',
        '-----  ',
        '-------',
        '-------',
        '  -----',
        '-------',
        '-------',
        '-----  ',
        '-------',
        '-------',
        '  -----',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '--   --',
        '-------',
        '-------',
        '-------',
        '  -----',
        '-------',
        '-------',
        '-----  ',
        '-------',
        '-------',
        '  -----',
        '-------',
        '-------',
        '---B---',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        '-------',
        'FFFFFFF',
    ],
};
